import css from "./index.module.css";

const Connection = ({from, to, prequisiteId, studentToMission}) => {

  const xOffset = 40;
  const isUnlocked = studentToMission?.filter(e => e.mission_id === prequisiteId && e.completed === true).length > 0 || prequisiteId === "";
  return (
    <line className={isUnlocked ? css.activeLine : css.inactiveLine} x1={from.x + xOffset} y1={from.y} x2={to.x + xOffset} y2={to.y}></line>
  )
}

export default Connection;